// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4adf94f9","887":"bb1faa69"}[chunkId] + ".chunk.js";
};